import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Link, useHistory, useLocation } from 'react-router-dom';
import styled from '@emotion/styled';
import theme from '../../../styles/theme';

import { IconButton, Logo, Avatar, Badge } from '../../atoms';
import { TextField, Menu } from '../../molecules';
import { useUserContext } from '../../../contexts/UserContext';

const Header = styled.header`
  position: sticky;
  top: 0;
  z-index: 2;
`;

const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: ${theme.colors.white};
  box-sizing: border-box;
  padding: 0 ${theme.spacing.xl};
  height: ${theme.headerHeight};
  margin: auto;
  max-width: 1280px;

  & > div {
    display: flex;
  }
`;

const VerticalCenter = styled.div`
  display: flex;
  align-items: center;
`;

const MenuIcon = styled(IconButton)`
  display: none;

  ${theme.mediaQuery('tablet')} {
    display: block;
  }
`;

const Form = styled.form`
  margin-left: ${theme.spacing.m};

  ${theme.mediaQuery('tablet')} {
    display: none;
  }
`;

const IconContainer = styled.div`
  display: flex;
  align-items: center;
`;

const AvatarContainer = styled.div`
  margin-left: ${theme.spacing.l};
  position: relative;

  ${theme.mediaQuery('tablet')} {
    display: none;
  }
`;

const MAX_NOTIFICATION_COUNT = 9;

const HeaderBar = ({ src, avatarAlt, dot, onToggleNav }) => {
  const history = useHistory();
  const [isVisible, setVisible] = useState(false);
  const { pathname } = useLocation();

  const handleToggle = () => {
    setVisible((state) => !state);
  };

  const {
    user: { notifications },
    handleLogOut,
  } = useUserContext();

  const submitLogOut = async () => {
    await handleLogOut();

    history.push('/login');
  };

  const reloadHome = () => {
    if (pathname === '/') {
      window.location.replace('/');
    }
  };

  return (
    <Header>
      <HeaderContainer>
        <MenuIcon size={theme.iconSizes.l} name="menu" onClick={onToggleNav} />
        <VerticalCenter>
          <Link
            to="/"
            onClick={reloadHome}
            style={{
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <Logo size={theme.iconSizes.xl} alt="logo" />
          </Link>
          <Form>
            <TextField
              size="sm"
              placeholder="검색어를 입력하세요"
              name="search"
              iconName="search"
            />
          </Form>
        </VerticalCenter>
        <div>
          <IconContainer>
            <Link to="/notifications">
              <Badge
                count={
                  notifications?.filter(({ seen, comment }) => !seen && comment)
                    .length
                }
                maxCount={MAX_NOTIFICATION_COUNT}
                dot={dot}
              >
                <IconButton size={32} />
              </Badge>
            </Link>
          </IconContainer>
          <AvatarContainer>
            <Avatar
              src={src}
              alt={avatarAlt}
              onClick={handleToggle}
              style={{ cursor: 'pointer' }}
            />
            <Menu
              isVisible={isVisible}
              style={{ position: 'absolute', right: 0 }}
            >
              <Menu.Item href="/settings">설정</Menu.Item>
              <Menu.Item href="/login" onClick={submitLogOut}>
                로그아웃
              </Menu.Item>
            </Menu>
          </AvatarContainer>
        </div>
      </HeaderContainer>
    </Header>
  );
};

HeaderBar.propTypes = {
  src: PropTypes.string,
  avatarAlt: PropTypes.string.isRequired,
  dot: PropTypes.bool,
  onToggleNav: PropTypes.func,
};

HeaderBar.defaultProps = {
  src: 'https://picsum.photos/200',
  dot: false,
  onToggleNav: () => {},
};

export default HeaderBar;
